<template>
  <div>
    <van-grid :column-num="n" clickable :border="false" :center="false">
      <van-grid-item v-for="(mi, index) in list" :key="index + mi.ItemName">
        <!-- DispName=span=>表示間隔一個欄 -->
        <div v-if="mi.DispName == 'span'"></div>
        <div v-else style="text-align: center" @click="cmdMI(mi)">
          <!-- <ImgItem
            :src="mi.ImgFile"
            :qty="getItemQty(mi)"
            v-if="soldOut(mi)"
            class="sold-out"
          />
          <ImgItem :src="mi.ImgFile" :qty="getItemQty(mi)" v-else /> -->
          <ImgItem :src="mi.ImgFile" :qty="getItemQty(mi)" />
          <div v-bind:class="sGetConfig('chkMenuFontSizeLarge') ? 'fx12' : ''">
            {{ mi.DispName }}
          </div>
          <div style="margin: 0.4rem">
            <div v-if="!soldOut(mi)" class="C1">{{ getPrice(mi) }}</div>
            <van-tag v-if="soldOut(mi)" round type="primary" size="large" color="#999"
              >售完</van-tag
            >
          </div>
          <div v-if="gGetDcText(mi)">
            <span class="tag">{{ gGetDcText(mi) }}</span>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<style scoped>
.van-image {
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
.sold-out {
  /* background-color: rgba(1, 1, 1, 0.6); */
  filter: grayscale(100%);
}
</style>

<script>
import ImgItem from "./ImgItem.vue";
export default {
  components: {
    ImgItem,
  },
  props: {
    bkmenu: Object,
    ordertmp: Array,
    list: Array,
    n: Number,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getPrice(pItem) {
      let price = Number(pItem.Price1);
      if (this.sGetConfig("chkCarHide0Price") && price == 0) return "";
      return "$" + price;
    },
    soldOut(item) {
      var find = this.sStopSale.find((r) => r.ItemName == item.ItemName);
      if (find) {
        return true;
      }
      return false;
    },
    getItemQty(item) {
      const ordertmp = this.$store.state.sOrdertmp;
      if (ordertmp == undefined) return 0;
      var array = ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    cmdMI(obj) {
      var find = this.sStopSale.find((r) => r.ItemName == obj.ItemName);
      if (find) {
        return this.gMsgbox("此項目已售完");
      }

      this.$emit("click", obj);
    },
  },
};
</script>
